import { Fragment } from 'react'
import {
  Text,
  GreyGrey70,
  GreyGrey80,
  Primary13Regular,
  Grid
} from '@sequencehq/core-components'

export const CustomerCustomProperties = ({
  customProperties
}: {
  customProperties: Record<string, string>
}) => {
  const entries = Object.entries(customProperties)

  if (entries.length === 0) {
    return null
  }

  return (
    <Grid
      templateColumns="150px 1fr"
      gap={4}
      height="fit-content"
      color={GreyGrey80}
      data-testid="customer-meta.customProperties"
    >
      {entries.map(([key, value]) => (
        <Fragment key={key}>
          <Text {...Primary13Regular} color={GreyGrey70}>
            {key}
          </Text>
          <Text
            {...Primary13Regular}
            color={GreyGrey80}
            data-testid={`customer-meta.customProperty.${key}`}
          >
            {value}
          </Text>
        </Fragment>
      ))}
    </Grid>
  )
}
